import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAllJobsTrackerListApi,
  addJobProgressCommentApi,
  getAllJobProgressCommentsApi,
  getAllOpenJobsListApi,
  addDocumentLinkApi,
  getDocumentsLinkApi,
  deleteDocumentLinkApi,
  getAllAssignedClientsOpenJobsApi,
  getAllOpenItemsApi,
  getWithStatusOpenItemsApi,
  getFileFolderCountApi,
  getInvoiceCountApi,
  getDailyActiveUserReportApi,
  getUserSessionLoginCountReportApi,
  getMonthlyActiveUserReportApi,
  getUserReportApi,
  getUserWiseInvoiceCountApi,
  getAllEInvoiceEWayBillListApi,
  getAllClientLockDateApi,
  getAllExternalUserEmailerApi,
  getInvoiceCountMonthlyGraphApi,
  getAllUserApprovedEntryApi,
  getAllClientBulkUploadReportApi,
  getUserWiseOCRReportApi,
  getClientWiseOCRReportApi,
  getAllBankStatementUploadReportApi,
} from "@/apis/listingApis";

import type {
  AddDocumentLinkPayloadType,
  AddJobProgressCommentPayload,
  DeleteDocumentLinkPayloadType,
  GetAllAssignedClientsOpenJobsPayloadType,
  GetAllDocumentsLinkPayloadType,
  GetAllOpenItemsPayload,
  GetJobProgressCommentsPayload,
  GetJobTrackerListingPayload,
  GetWithStatusOpenItemsPayload,
  GetAllOpenJobListPayload,
  GetFileFolderCountPayloadType,
  GetAdvenceInvoiceCountPayloadType,
  GetDailyActiveUserCountPayloadType,
  GetUserSessionLoginCountPayloadType,
  GetMonthlyActiveUserCountPayloadType,
  GetUserReportCountPayloadType,
  GetUserWiseInvoiceCountPayloadType,
  GetAllEInvoiceEWayBillListType,
  GetAllClientLockDateListType,
  GetAllExternalEmailerListType,
  GetInvoiceCountMonthlyPayloadType,
  GetAllUserApprovedEntryListType,
  GetAllClientBulkUploadHistoryPayloadType,
  GetUserWiseOCRReportPayloadType,
  GetClientWiseOCRReportPayloadType,
  GetAllBankStatementUploadReportPayloadType,
} from "@/commonTypes/listing";

export const getAllJobsTrackerListAction = createAsyncThunk(
  "listing/jobTrackerList",
  async (data: GetJobTrackerListingPayload) => {
    const response = await getAllJobsTrackerListApi(data);
    return response.data;
  }
);

export const getAllJobProgressCommentsAction = createAsyncThunk(
  "listing/getJobComments",
  async (data: GetJobProgressCommentsPayload) => {
    const response = await getAllJobProgressCommentsApi(data);
    return response.data;
  }
);

export const addJobProgressCommentAction = createAsyncThunk(
  "listing/addJobProgressComment",
  async (data: AddJobProgressCommentPayload) => {
    const response = await addJobProgressCommentApi(data);
    return response.data;
  }
);

export const getAllOpenJobsListAction = createAsyncThunk(
  "listing/allOpenJobsList",
  async (data: GetAllOpenJobListPayload) => {
    const response = await getAllOpenJobsListApi(data);
    return response.data;
  }
);

export const addDocumentLinkAction = createAsyncThunk(
  "listing/addDocumentLink",
  async (data: AddDocumentLinkPayloadType) => {
    const response = await addDocumentLinkApi(data);
    return response.data;
  }
);

export const getDocumentsLinkAction = createAsyncThunk(
  "listing/getDocumentsLink",
  async (data: GetAllDocumentsLinkPayloadType) => {
    const response = await getDocumentsLinkApi(data);
    return response.data;
  }
);

export const deleteDocumentLinkAction = createAsyncThunk(
  "listing/deleteDocumentLink",
  async (data: DeleteDocumentLinkPayloadType) => {
    const response = await deleteDocumentLinkApi(data);
    return response.data;
  }
);

export const getAllAssignedClientsOpenJobsAction = createAsyncThunk(
  "listing/assignedClientsOpenJobsList",
  async (data: GetAllAssignedClientsOpenJobsPayloadType) => {
    const response = await getAllAssignedClientsOpenJobsApi(data);
    return response.data;
  }
);

export const getAllOpenItemsAction = createAsyncThunk(
  "listing/getAllOpenItems",
  async (data: GetAllOpenItemsPayload) => {
    const response = await getAllOpenItemsApi(data);
    return response.data;
  }
);

export const getWithStatusOpenItemsAction = createAsyncThunk(
  "listing/getWithStatusOpenItems",
  async (data: GetWithStatusOpenItemsPayload) => {
    const response = await getWithStatusOpenItemsApi(data);
    return response.data;
  }
);

export const getFileAndFolderAction = createAsyncThunk(
  "reports/getFileAndFolder",

  async (data: GetFileFolderCountPayloadType) => {
    const response = await getFileFolderCountApi(data);
    return response.data;
  }
);

export const getAdvanceInvoiceCountAction = createAsyncThunk(
  "reports/getInvoiceCount",
  async (data: GetAdvenceInvoiceCountPayloadType) => {
    const response = await getInvoiceCountApi(data);
    return response.data;
  }
);

export const getDailyActiveUserReportAction = createAsyncThunk(
  "reports/getDailyActiveUser",
  async (data: GetDailyActiveUserCountPayloadType) => {
    const response = await getDailyActiveUserReportApi(data);
    return response.data;
  }
);

export const getUserSessionLoginCountReportAction = createAsyncThunk(
  "reports/getUserSessionLoginCount",
  async (data: GetUserSessionLoginCountPayloadType) => {
    const response = await getUserSessionLoginCountReportApi(data);
    return response.data;
  }
);

export const getMonthlyActiveUserReportAction = createAsyncThunk(
  "reports/getMonthlyActiveUser",
  async (data: GetMonthlyActiveUserCountPayloadType) => {
    const response = await getMonthlyActiveUserReportApi(data);
    return response.data;
  }
);

export const getUserReportAction = createAsyncThunk(
  "reports/getUserReport",
  async (data: GetUserReportCountPayloadType) => {
    const response = await getUserReportApi(data);
    return response.data;
  }
);

export const getUserWiseInvoiceCountReportAction = createAsyncThunk(
  "reports/getUserWiseInvoiceCount",
  async (data: GetUserWiseInvoiceCountPayloadType) => {
    const response = await getUserWiseInvoiceCountApi(data);
    return response.data;
  }
);

export const getAllEInvoiceEWayBillListAction = createAsyncThunk(
  "adminReports/getAllEnvoiceEwayBillList",
  async (data: GetAllEInvoiceEWayBillListType) => {
    const response = await getAllEInvoiceEWayBillListApi(data);
    return response.data;
  }
);

export const getAllClientLockDateAction = createAsyncThunk(
  "reports/getAllClientLockDate",
  async (data: GetAllClientLockDateListType) => {
    const response = await getAllClientLockDateApi(data);
    return response.data;
  }
);

export const getAllExternalUserEmailerAction = createAsyncThunk(
  "reports/getAllExternalUserEmailer",
  async (data: GetAllExternalEmailerListType) => {
    const response = await getAllExternalUserEmailerApi(data);
    return response.data;
  }
);

export const getMonthlyInvoiceCountGraphAction = createAsyncThunk(
  "invoiceCount/getMonthlyGraph",
  async (data: GetInvoiceCountMonthlyPayloadType) => {
    const response = await getInvoiceCountMonthlyGraphApi(data);
    return response.data;
  }
);

export const getAllUserApprovedEntryAction = createAsyncThunk(
  "reports/getAllUserApprovedEntry",
  async (data: GetAllUserApprovedEntryListType) => {
    const response = await getAllUserApprovedEntryApi(data);
    return response.data;
  }
);

export const getAllClientBulkUploadReportAction = createAsyncThunk(
  "reports/getAllClientBulkUpload",
  async (data: GetAllClientBulkUploadHistoryPayloadType) => {
    const response = await getAllClientBulkUploadReportApi(data);
    return response.data;
  }
);

export const getUserWiseOCRReportAction = createAsyncThunk(
  "reports/getUserWiseOCRReport",
  async (data: GetUserWiseOCRReportPayloadType) => {
    const response = await getUserWiseOCRReportApi(data);
    return response.data;
  }
);

export const getClientWiseOCRReportAction = createAsyncThunk(
  "reports/getClientWiseOCRReport",
  async (data: GetClientWiseOCRReportPayloadType) => {
    const response = await getClientWiseOCRReportApi(data);
    return response.data;
  }
);

export const getAllBankStatementUploadReportAction = createAsyncThunk(
  "reports/getAllBankStatementUploadReport",
  async (data: GetAllBankStatementUploadReportPayloadType) => {
    const response = await getAllBankStatementUploadReportApi(data);
    return response.data;
  }
);
